var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-input", {
    attrs: {
      autosize: { minRows: 3 },
      maxlength: 800,
      disabled: _vm.disabled,
      type: "textarea",
      resize: "none",
      "show-word-limit": "",
    },
    on: { input: _vm.valueChange },
    model: {
      value: _vm.dataValue,
      callback: function ($$v) {
        _vm.dataValue = $$v
      },
      expression: "dataValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }